var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sex_choice"}},[_c('dd',[_vm._v("送る相手を選んでね")]),_c('div',{staticClass:"button"},[_c('button',{on:{"click":_vm.handleWomen}},[_vm._v("女の子用")]),_c('button',{on:{"click":_vm.handleMen}},[_vm._v("男の子用")])])])}
var staticRenderFns = []

export { render, staticRenderFns }